<div class="all-in-one-table content-layout">
  <div [ngClass]="elements>5?'example-container':'none'" style="overflow-x:auto;z-index: 1;">
    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">


      <mat-card class="summary-card">
        <div class="summary-content">
          <!-- Left block -->
          <div class="col left">
            <h1 class="amount mat-headline-small">
              {{ openDealsAmount }}
            </h1>

            <div class="meta">
              <span class="count mat-body-strong">{{ openDealsCount }}</span>
              <span class="label mat-body-medium">Total deals Amount</span>
            </div>
          </div>

          <!-- Dashed divider -->
          <div class="divider" role="separator" aria-hidden="true"></div>

          <!-- Right block -->
          <div class="col right">
            <h1 class="amount mat-headline-small">
              {{ wonDealAmount}}
            </h1>

            <div class="meta">
              <span class="count mat-body-strong">{{ wonDealAmountCount }}</span>
              <span class="label mat-body-medium">Won deal Amount</span>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
    <br>
    <table class="products-padding" mat-table [dataSource]="companyList" matSort (matSortChange)="sortData($event)"
      style="user-select:none">

      <!-- Dynamic data columns -->
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.property">

        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ column.name }}
        </th>

        <td mat-cell *matCellDef="let row" [ngClass]="column.cssClasses" [attr.data-label]="column.name">


          <ng-container *ngIf="column.property === 'closingDate'">


            <calsoft-date-format-issue [date]="row.closingDates !== undefined ? row.closingDates : row.closingDate">

            </calsoft-date-format-issue>
          </ng-container>

          <ng-container *ngIf="column.property === 'amount'">

            {{ currencyConvertPipe.transform( row.amount ) }}
          </ng-container>

          <ng-container *ngIf="column.property === 'paid'">

            {{ currencyConvertPipe.transform( row.paid ) }}
          </ng-container>

          <ng-container *ngIf="column.property === 'balance'">

            {{ currencyConvertPipe.transform( row.balance ) }}
          </ng-container>

          <ng-container *ngIf="column.property!='actions'  
         && column.property != 'amount'
         && column.property != 'paid'
            && column.property != 'balance'
         && column.property != 'closingDate'">
            {{ row[column.property] }}
          </ng-container>



          <ng-container *ngIf="column.property=='actions'">

            <button [attr.guide]="'deal-table-btn-1' + '__' + sanitizedUrl" type="button" mat-icon-button
              [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
              <button [attr.guide]="'deal-table-btn-2' + '__' + sanitizedUrl"
                (click)="editProduct(row.entityId, row.attributeSetId)" mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button [attr.guide]="'deal-table-btn-3' + '__' + sanitizedUrl" (click)="deleteAllProductId(row.entityId)"
                mat-menu-item>
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </ng-container>
        </td>

      </ng-container>



      <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable"></tr>
    </table>

    <div class="products-padding" fxLayoutAlign="center center" *ngIf="!companyList?.length">
      No records found
    </div>

    <div style="width: 100%;" *ngIf="companyList?.length>0">
      <mat-spinner fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" [diameter]="20"
        *ngIf="spinner"></mat-spinner>
      <mat-paginator fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" class="paginator"
        (page)="getUpdate($event)" showFirstLastButtons [length]="pageList" [pageIndex]="page" [pageSize]="size"
        [pageSizeOptions]="pageSizeValue">
      </mat-paginator>

    </div>
  </div>